export function spreedParams(preload) {
    preload = preload || {}
    const {
        success,
        fail,
        final,
        ...params
    } = preload
    const call = {
        success,
        fail,
        final,
    }
    return { params, call}
}